
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/short-internships/corp-contact",
      function () {
        return require("private-next-pages/next/short-internships/corp-contact.tsx");
      }
    ]);
  